module.exports = __webpack_public_path__ + "img/warning.954ec08b.svg";